import NotInformation from '../../../../../components/NotInformation';
import FileCardList from '../../SubComponents/FileCardList';
import DocumentationTabApp from "../Functionality/DocumentationTabApp";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DocumentationTab = ({ t, id, userTypeId, profile, noInformationTitle }) => {
    const {documentationData } = DocumentationTabApp({
        id,
        profile,
        userTypeId,
    })


    return (
        <>
            {documentationData?.length === 0 ? (
                <NotInformation
                     text={t(noInformationTitle)}
                    card={true}
                    className={"h-500px"}
                />
            ) : (
                <>
                    <div className='h-500px overflow-y-auto'>
                        {documentationData?.map((item) => <FileCardList item={item}/>)}
                    </div>
                </>
            )}
        </>
    );
};

export default DocumentationTab;
